<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">手机轮播</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh">
          <template #cover="{ row }">
            <img
              v-if="row.cover"
              :src="row.cover"
              alt=""
              class="cover_img"
              @click="click_cover(row.cover)"
            />
          </template>
          <template #isEnable="{ row }">
            <el-switch
              v-model="row.isEnable"
              @change="handleSwitch(row)"
            />
          </template>
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="View"
              link
              @click="click_view(row)"
            >查看</el-button>
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_edit(row)"
            >编辑</el-button>
            <ConfirmButton
              style="color: #6fcaf7"
              icon="Delete"
              link
              @confirm="click_delete(row)"
            >删除</ConfirmButton>
          </template>
        </MyTable>
        <MyPagination :params="getListParams" :total="total" @get-list="getList" ref="pagination" />
      </div>
    </div>
    <Dialog
      v-model="addVisible"
      title="新增"
      top="5vh"
      @closed="handleClosed"
    >
      <el-form class="addForm" ref="formRef" :model="formData" label-width="auto" style="padding: 20px 40px;">
        <el-form-item label="封面:" prop="cover" :class="{'from-readonly': readonly}">
          <ImgUpload v-model="formData.cover" />
          <div class="tip" style="margin-left: 20px;">(建议上传690*150px的图片)</div>
        </el-form-item>
        <el-form-item label="标题:" prop="title">
          <el-input v-model="formData.title" :readonly="readonly"></el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content">
          <RichText
            v-model="formData.content"
            style="height: 350px;"
            defaultUpload
            ref="editorRef"
            :readonly="readonly"
          />
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button plain @click="addVisible = false">取消</el-button>
        <MyButton @click="click_confirm">确定</MyButton>
      </div>
    </Dialog>
    <Dialog v-model="dialogImgVisible" title="图片预览" top="5vh">
      <img :src="dialogImageUrl" alt="Preview Image" style="width: 100%" />
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import { computed, nextTick, reactive, ref } from "vue";
import MyButton from "@/components/Global/MyButton.vue";
import educationApi from "@/api/education.js";
import MyPagination from "@/components/Global/MyPagination.vue";
import Dialog from "@/components/Common/Dialog.vue";
import RichText from "@/components/RichText.vue";
import ImgUpload from "@/components/Common/ImgUpload.vue";
import ConfirmButton from "@/components/Common/ConfirmButton.vue";
import { cloneDeep } from "lodash-es";
import { dayjs, ElMessage } from "element-plus";

// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "input",
      label: "关键字：",
      prop: "Title",
      attrs: {
        placeholder: "请输入",
      }
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(getListParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "重置",
      attrs: {
        icon: "Refresh",
      },
      events: {
        click(formData) {
          formData.Title = "";
          Object.assign(getListParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "新增轮播",
      attrs: {
        icon: "Plus",
      },
      events: {
        click(formData) {
          addVisible.value = true;
        },
      },
    },
  ],
});

const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 60 },
    { type: "slot", label: "banner轮播图", slot_name: "cover",minWidth: 100 },
    { label: "标题", prop: "title" },
    { label: "创建时间", prop: "creationTime" },
    { type: "slot", label: "是否启用", slot_name: "isEnable" },
    { type: "slot", slot_name: "handler", label: "操作", width: 300 },
  ],
  tableData: [],
});

// 分页
const pagination = ref();
const total = ref(0);
const getListParams = reactive({
  
})
const getList = (params = pagination.value.getList_Params) => {
  educationApi.getBannerList(params).then((res) => {
    tableOptions.tableData = res.data.items.map(item=>{
      item.creationTime = dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss');
      return item
    });
    total.value = res.data.totalCount;
  })
}

// 删除
const click_delete = (row) => {
  educationApi.deleteBanner(row.id).then((res) => {
    ElMessage.success("删除成功");
    getList();
  })
};
const click_view = (row) => {
  readonly.value = true;
  addVisible.value = true;
  formData.value = cloneDeep(row);
}
// 编辑
const click_edit = (row) => {
  readonly.value = false;
  addVisible.value = true;
  formData.value = cloneDeep(row);
};
const handleSwitch = (row) => {
  educationApi.editBanner(row).then((res) => {
    ElMessage.success("操作成功");
    getList();
  })
}
// 图片预览
const click_cover = (url) => {
  dialogImageUrl.value = url;
  dialogImgVisible.value = true;
};
const dialogImgVisible = ref(false); //预览图片dialog
const dialogImageUrl = ref(""); //预览图片地址

// 新增轮播图
const addVisible = ref(false);
const readonly = ref(false);
const formData = ref({
  title: "",
  cover: "",
  content: "",
});

const formRef = ref(null);
const click_confirm = async () => {
  if(readonly.value){
    addVisible.value = false;
    return
  }
  formRef.value.validate(async (valid) => {
    if (valid) {
      formData.value.id ? await educationApi.editBanner(formData.value)
      : await educationApi.addBanner(formData.value)
      ElMessage.success(`${formData.value.id ? '编辑' : '新增'}成功`);
      addVisible.value = false;
      getList();
    }
  })
};
// 弹框关闭回调
const handleClosed = () => {
  clearForm();
};
// 清空表单值
const clearForm = () => {
  formData.value = {
    title: "",
    cover: "",
    content: "",
  };
};
</script>

<style lang="scss" scoped>
.cover_img {
  width: 100px;
  height: 70px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
